import { MutableMap } from './aliases';
export const memoizeFunction = (fn, argsToCacheKey) => {
    const cache = new MutableMap();
    return (...args) => {
        const key = argsToCacheKey(...args);
        const cachedValue = cache.get(key);
        if (cachedValue !== undefined) {
            return cachedValue;
        }
        else {
            const result = fn(...args);
            cache.set(key, result);
            return result;
        }
    };
};
